module.exports = __webpack_public_path__ + "assets-customer/images/kids-category.png?5072cc9f";